import { useEffect } from 'react';

import { getQueryParamValue } from 'src/lib/browser';
import { ROUTE_PARAMS } from 'src/routes';
import { useCurrentUser } from 'src/store';

import { clampDisplayMode, DISPLAY_MODE } from '../const';
import { useMainActions } from '../store';

const getDefaultDisplayMode = () => {
  const defaultMode = DISPLAY_MODE.list;

  const queryMode = getQueryParamValue(ROUTE_PARAMS.view);
  if (queryMode) {
    return clampDisplayMode(queryMode, defaultMode);
  }

  return defaultMode;
};

export const useInitDisplayMode = () => {
  const currentUser = useCurrentUser();
  const mainActions = useMainActions();

  useEffect(() => {
    if (!currentUser) {
      return;
    }

    // Don't reinit if MODE was already set
    if (mainActions.getDisplayMode()) {
      return;
    }

    const initialMode = getDefaultDisplayMode();
    mainActions.activateDisplayMode(initialMode);
  }, [currentUser, mainActions]);
};
